module.exports = __webpack_public_path__ + "img/uconn-school-of-pharmacy.0c458de2.png";